// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__22kU0","select":"Header_select__3qS2g","clinic":"Header_clinic__rV39R"};